export default __webpack_public_path__ + "static/media/PlusIcon.936aa28e.svg";